import {Route, Routes} from 'react-router-dom';
import {List} from './List';

export default function ThayTheNhieuHoaDon() {

  return (
    <Routes>
      <Route path="/" element={<List/>}/>
    </Routes>
  );
}
